import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from '../components/Sidebar';
import GameMenu from '../components/GameMenu';
import Timer from '../components/Timer';
import EndGameBtn from '../components/EndGameBtn';
import Popup from '../components/Popup';
import '../assets/css/mixedwords.css'

const GRID_SIZE = 10;
const MOTS = ["CHAT", "MAISON", "POMME", "VOITURE"];

export default function MixedWords() {
    const [timerIsFinished, setTimerIsFinished] = useState(false);
    const [timeElapsed, setTimeElapsed] = useState(0);

    const sendTime = (time) => {
        setTimeElapsed(time);
    };

    const [grid, setGrid] = useState([]);
    const [motsPlaces, setMotsPlaces] = useState([]);
    const [selection, setSelection] = useState({ start: null, end: null });
    const [selectedCells, setSelectedCells] = useState([]);
    const [wrongWords, setWrongWords] = useState([]);
    const [foundWords, setFoundWords] = useState([]);

    useEffect(() => {
        const { grid: newGrid, positions } = generateGrid(GRID_SIZE, MOTS);
        setGrid(newGrid);
        setMotsPlaces(positions.map(p => p.word));
    }, []);

    useEffect(() => {
        if (foundWords.length === MOTS.length) {
            console.log('FIN DU JEU');
            setTimerIsFinished(true);
            // Tu peux mettre ici d'autres actions à faire à la fin
        }
    }, [foundWords]);

    function generateGrid(size, words) {
      const grid = Array.from({ length: size }, () =>
        Array.from({ length: size }, () => "")
      );

      const positions = [];

      for (const word of words) {
        let placed = false;
        let attempts = 0;

        while (!placed && attempts < 100) {
          const dir = Math.random() < 0.5 ? "H" : "V";
          const row = Math.floor(Math.random() * size);
          const col = Math.floor(Math.random() * size);

          if (canPlaceWord(grid, word, row, col, dir)) {
            placeWord(grid, word, row, col, dir);
            positions.push({ word, row, col, dir });
            placed = true;
          }
          attempts++;
        }
      }

      // Remplir les cases vides avec des lettres aléatoires
      const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      for (let r = 0; r < size; r++) {
        for (let c = 0; c < size; c++) {
          if (grid[r][c] === "") {
            grid[r][c] = alphabet[Math.floor(Math.random() * alphabet.length)];
          }
        }
      }

      return { grid, positions };
    }

    function canPlaceWord(grid, word, row, col, dir) {
      const size = grid.length;

      if (dir === "H") {
        if (col + word.length > size) return false;
        for (let i = 0; i < word.length; i++) {
          const cell = grid[row][col + i];
          if (cell !== "" && cell !== word[i]) return false;
        }
      } else {
        if (row + word.length > size) return false;
        for (let i = 0; i < word.length; i++) {
          const cell = grid[row + i][col];
          if (cell !== "" && cell !== word[i]) return false;
        }
      }

      return true;
    }

    function placeWord(grid, word, row, col, dir) {
      if (dir === "H") {
        for (let i = 0; i < word.length; i++) {
          grid[row][col + i] = word[i];
        }
      } else {
        for (let i = 0; i < word.length; i++) {
          grid[row + i][col] = word[i];
        }
      }
    }

    // HANDLE SELECTION
    const handleMouseDown = (x, y) => {
        setSelection({ start: { x, y }, end: null });
        setSelectedCells([{ x, y }]);
    };

    const handleMouseEnter = (x, y) => {
        if (!selection.start) return;

        const newEnd = { x, y };
        const cells = getCellsBetween(selection.start, newEnd);
        if (cells) {
            setSelection({ ...selection, end: newEnd });
            setSelectedCells(cells);
        }
    };

    const handleMouseUp = () => {
        if (selectedCells.length > 0) {
            const selectedWord = selectedCells.map(cell => grid[cell.x][cell.y]).join("");
            console.log("Mot sélectionné :", selectedWord);

            // if (MOTS.includes(selectedWord)) {
            //     console.log(" It's a match !");
            // } else {
            //     console.log(" Wrong :(");
            // }

          // Avec mots inversés
            const reversedWord = selectedWord.split("").reverse().join("");
            if (MOTS.includes(selectedWord) || MOTS.includes(reversedWord)) {
                const matched = MOTS.includes(selectedWord) ? selectedWord : reversedWord;
                console.log(" It's a match !");
                console.log(selectedCells);
                if (!foundWords.includes(matched)) {
                    setFoundWords(prev => [...prev, matched]);
                }
            } else {
                console.log("❌ Wrong :(");
                if (selectedWord.length > 3) {
                    setWrongWords(prev => [...prev, selectedWord]);
                }
            }
        }

        setSelection({ start: null, end: null });
        setSelectedCells([]);
    };

    // if (foundWords.length === MOTS.length) {
    //   console.log('FIN DU JEU')
    // }

    // Récupère les cellules entre deux points dans une ligne/colonne/diagonale
    function getCellsBetween(start, end) {
        const dx = end.x - start.x;
        const dy = end.y - start.y;

        const length = Math.max(Math.abs(dx), Math.abs(dy));

        const stepX = dx === 0 ? 0 : dx / Math.abs(dx);
        const stepY = dy === 0 ? 0 : dy / Math.abs(dy);

        // Valide seulement si H, V ou diagonale
        if (
            !(dx === 0 || dy === 0 || Math.abs(dx) === Math.abs(dy))
        ) {
            return null;
        }

        const cells = [];
        for (let i = 0; i <= length; i++) {
            const x = start.x + i * stepX;
            const y = start.y + i * stepY;
            if (x >= 0 && y >= 0 && x < GRID_SIZE && y < GRID_SIZE) {
                cells.push({ x, y });
            }
        }

        return cells;
    }

    const location = useLocation();
    const { theme, subTheme } = location.state || {};

    return (
        <div className="page-container">
            <Sidebar />

            <div className="content-container inGame" id="mixedWords">
                <div className="title">
                    <h4>{theme} - {subTheme} </h4>
                    <div className="level-infos">
                        <p> Niveau ??</p>
                        <Timer timer={timerIsFinished} onFinish={() => setTimerIsFinished(true)} onSendTime={sendTime} />
                    </div>
                </div>

                <div className="game-container launched">
                    <div className="mixedwords_game_container launched">
                        <div id="mixedwords_failed_words_container" className="mixedwords_failed_word_container">
                            {wrongWords.map((mot, index) => (
                              <span key={index} className="wrong-word">{mot}</span>
                            ))}
                        </div>

                        <div className="flex-grow-1" id="mixedwords_grid_container">
                            <div className="grid">
                                {/* {grid.map((row, x) =>
                                    row.map((cell, y) => (
                                        <div className="cell justify-content-center" data-x={x} data-y={y} key={`${x}-${y}`}>
                                        {cell}
                                        </div>
                                    ))
                                )} */}
                                {grid.map((row, x) =>
                                  row.map((cell, y) => {
                                      const isSelected = selectedCells.some(c => c.x === x && c.y === y);
                                      return (
                                          <div
                                              className={`cell justify-content-center ${isSelected ? "selected" : ""}`}
                                              key={`${x}-${y}`}
                                              onMouseDown={() => handleMouseDown(x, y)}
                                              onMouseEnter={() => handleMouseEnter(x, y)}
                                              onMouseUp={handleMouseUp}
                                          >
                                              {cell}
                                          </div>
                                      );
                                  })
                              )}
                            </div>
                        </div>
                        
                        <div id="mixedwords_words_container" className="mixedwords_word_container">
                            {MOTS.map((mot, idx) =>
                                motsPlaces.includes(mot) ? (
                                    <span
                                        className={`word ${foundWords.includes(mot) ? "filled" : ""}`}
                                        data-word={mot}
                                        key={idx}
                                    >
                                        {mot}
                                    </span>
                                ) : null
                            )}
                        </div>
                    </div>
                </div>
                <EndGameBtn onClick={() => setTimerIsFinished(true)} />
            </div>
            <GameMenu />
            <Popup time={timeElapsed} timerIsFinished={timerIsFinished} />
        </div>
    )
}